module.exports = __webpack_public_path__ + "img/map.6676c670.svg";